<template>
  <div :class="(onlyMultiUploadDocuments && onlySmallScreenMultiUpload) ? 'mt-3 mx-3' : 'mt-3'">
    <h5 class="text-nowrap">Добавление документа</h5>
    <div class="row active-panel-block align-items-center m-0 mt-4" v-if="!onlyMultiUploadDocuments && needMultiUploadDocuments">
      <div class="active-panel-block_icon">
        <b-icon icon="grip-vertical" font-scale="2" class="text-secondary"></b-icon>
      </div>
      <template v-if="needMultiUploadDocuments">
        <div class="mr-auto">
          <b-form-checkbox
            v-model="multiUploadDocuments"
          >
            <b>Многофайловая загрузка</b>
          </b-form-checkbox>
        </div>
      </template>
      <div class="active-panel-block_action" v-if="!onlyMultiUploadDocuments">
        <template v-if="!multiUploadDocuments">
          <span @click="addMultiFile()" class="text-secondary cursor-pointer"><i class="fas fa-plus mr-1"></i> <b>Добавить файл</b></span>
        </template>
        <template v-else>
          <span
            @click="multipleFiles = []"
            :class="`text-secondary cursor-pointer ${multipleFiles.length == 0 ? 'not-trash' : 'trash'}`"
          >
          <i class="far fa-trash-alt mr-1"></i> <b>Очистить список</b>
          </span>
        </template>
      </div>
    </div>
    <b-overlay
      :show="dataOverlay"
      spinner-variant="success"
    >
      <template v-if="onlyMultiUploadDocuments || multiUploadDocuments">
        <div class="row mt-3">
          <div :class="!onlySmallScreenMultiUpload ? 'col-md-6' : 'col-md-12'">
            <div
              v-cloak @drop.prevent="handleFileUploads($event)"
              @dragover.prevent
              class="input-multi-upload"
            >
              <div class="row">
                <div class="col">
                  <img :src="'/img/upload-document.svg'" class="box__icon">
                </div>
              </div>
              <div class="row">
                <div class="col text-center">
                  <label for="file"><strong class="text-brown cursor-pointer">Выберите файлы</strong><span class="box__dragndrop text-secondary"> или перенесите в это поле</span></label>
                </div>
              </div>
            </div>
            <input type="file" id="file" class="box__file" ref="file-multiple-input" multiple @change="handleFileInputUploads($event)" v-if="resetInput">

          </div>
          <div :class="!onlySmallScreenMultiUpload ? 'col-md-6' : 'col-md-12 mt-4 mb-3'">
            <template v-if="multipleFiles.length > 0">
              <div>
                <ul class="list-group">
                  <li class="list-group-item item-preview-doc" v-for="(file, index) in multipleFiles" :key="index">{{ file.name }} <span class="remove-file float-right cursor-pointer" v-on:click="removeFile(index)"><i class="far fa-trash-alt doc-trash text-danger"></i></span></li>
                </ul>
              </div>
            </template>
            <template v-else>
              <div class="tsoft-alert">
                <span>Документы появятся после загрузки</span>
              </div>
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="form-row mt-3" v-for="(file, index) in files" :key="index">
          <div class="form-group col">
            <label>Название документа</label>
            <div class="mb-3"><input type="text" class="form-control" v-model="file.name"></div>
            <label for="reference_document_type_id">Тип документа</label>
            <tsoft-select-of-properties
              :reference_id="34"
              :needNullElement="false"
              :needMultipleSelect="false"
              :defaultSelectName="`Выберите тип документа`"
              :internalSearch="true"
              :selected="file.reference_document_type_id"
              :excludeArray="excludeAddDocumentTypeArray"
              @set="(value) => {file.reference_document_type_id = value}"
            ></tsoft-select-of-properties>
          </div>
          <div class="form-group col">
            <label>Описание</label>
            <b-form-textarea
              :id="`file_textarea_${index}`"
              v-model="file.description"
              placeholder=""
              rows="5"
              max-rows="5"
            ></b-form-textarea>
          </div>
          <div class="form-group col">
            <label>Дата составления документа</label>
            <div class="mb-3"><input type="date" class="form-control" v-model="file.date_of_document"></div>
            <label>Загрузить документ</label>
            <b-form-file
              @change="addFile(index, $event)"
              ref="file-input"
              placeholder="Выберите файл"
              drop-placeholder="Перенесите файл в это поле..."
            ></b-form-file>
            <small class="text-nowrap">Выберите файл, или перенесите его в поле загрузки*</small>
          </div>
          <div class="form-group col-1 text-center" v-if="files.length > 1">
            <b-button @click="deleteMultiFile(index)" class="trash_document btn-danger"><i class="fas fa-trash"></i></b-button>
          </div>
        </div>
      </template>
    </b-overlay>
    <div class="row mt-4" v-if="needUploadButton">
      <div :class="(onlyMultiUploadDocuments && onlySmallScreenMultiUpload) ? 'col text-center mb-3' : 'col text-right'">
        <button
          v-if="files.length >= 1"
          @click.prevent="loadingDocuments"
          class="btn btn-outline-primary"
        >Загрузить документ{{(multiUploadDocuments || onlyMultiUploadDocuments) ? 'ы' : ''}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { API_DOCUMENTS } from '../../constants';
import { defaultDataItems } from '../../mixins';

const initialNewFile = () => ({
  name: null,
  description: '',
  reference_document_type_id: 337,
  date_of_document: null,
  attachment: null,
  loaded: false,
  unit: ''
})

export default {
  mixins: [defaultDataItems],

  props: {
    orderId: { type: Number|String, required: false, default: '' },                                    //order id for adding document
    orderServiceId: { type: Number|String, required: false, default: '' },                             //order service id for adding document
    companyId: { type: Number|String, required: false, default: '' },                                  //company id for adding document
    financeId: { type: Number|String, required: false, default: '' },                                  //finance id for adding document
    commentId: { type: Number|String, required: false, default: '' },                                  //comment id for adding document
    taskId: { type: Number|String, required: false, default: '' },                                     //task id for adding document
    needUploadButton: { type: Boolean, default: true, required: false },                        // hide upload button
    uploadDocumentsNow: { type: Boolean, default: false, required: false },                     //activation of the component work process
    excludeAddDocumentTypeArray: { type: Array,
        required: false,
        default: function () {
            return [329, 330, 331, 332, 333, 338]
        }
    },                                                              //if you need to eclude document type for adding
    whereDocumentLoadingItemIndex: { type: Number | String, required: false, default: -1 },     //if we need to save editIndex
    needMultiUploadDocuments: { type: Boolean, required: false, default: false },               //enable multiboot
    onlyMultiUploadDocuments: { type: Boolean, required: false, default: false },               //enable only multiboot
    onlySmallScreenMultiUpload: { type: Boolean, required: false, default: false }              //demo option for good layout view on small screens - лучше сделать версткой грамотной!
  },

  data() {
    return {
      resetInput: true,
      files: [],
      multipleFiles: [],
      dataOverlay: false,
      multiUploadDocuments: false,
      areAnyFilesHere: false,
      unit: 'B2B'
    }
  },
  computed: {
    ...mapGetters("auth", ["currentUser"]),

    isB2CAccount() {
        return this.currentUser.role.includes('b2c-head-manager') || 
                this.currentUser.role.includes('b2c-manager');
    }
  },
  watch: {
    multiUploadDocuments: function(){
      this.multipleFiles = []
    },
    onlyMultiUploadDocuments: {
      handler(value) {
        if (value) {
            this.multiUploadDocuments = true
        }
      },
      immediate: true
    },
    uploadDocumentsNow: {
      handler(value) {
        if (value && this.orderId) {
          this.loadingDocuments()
        }
      },
      immediate: true
    }
  },

  mounted () {
    this.whereDocumentLoadingItemIndexLocal = this.whereDocumentLoadingItemIndex;
    this.addMultiFile();
  },

  methods: {
    //Методы для мультизагрузки документов
    handleFileUploads(e) {
      let uploadedFiles = e.dataTransfer.files;

      for (let i = 0; i < uploadedFiles.length; i++) {
        this.multipleFiles.push(uploadedFiles[i]);
      }
    },
    handleFileInputUploads(e) {
      let uploadedInputFiles = e.target.files;

      for (let i = 0; i < uploadedInputFiles.length; i++) {
        this.multipleFiles.push(uploadedInputFiles[i]);
      }

      e.target.value = '';
    },
    removeFile(key){
      this.multipleFiles.splice(key, 1)
    },
    addMultiFile() {
      this.files.push(initialNewFile())
    },
    deleteMultiFile(index) {
      this.files.splice(index, 1)
    },
    //processing uploaded file
    addFile(index, event) {
      if (event.target.files.length) {
        this.files[index].attachment = event.target.files[0];
        this.areAnyFilesHere = true;
      } else {
        this.areAnyFilesHere = false;
      }
    },
    //loading into the document database
    loadingDocuments() {
      this.unit = 'B2B';

      if (this.isB2CAccount) {
        this.unit = 'B2C';
      }

      if (this.areAnyFilesHere || this.multipleFiles.length) {
        this.dataOverlay = true;
        const config = { 'content-type': 'multipart/form-data' };

        const ORDER_ID = (typeof this.orderId === 'number') ? this.orderId : '';
        const COMPANY_ID = (typeof this.companyId === 'number') ? this.companyId : '';
        const FINANCE_ID = (typeof this.financeId === 'number') ? this.financeId : '';
        const ORDER_SERVICE_ID = (typeof this.orderServiceId === 'number') ? this.orderServiceId : '';
        const COMMENT_ID = (typeof this.commentId === 'number') ? this.commentId : '';
        const TASK_ID = (typeof this.taskId === 'number') ? this.taskId : '';

        if (this.multiUploadDocuments == false) {
          this.files.forEach((file, index) => {
            const formData = new FormData()
            formData.append('name', file.name)
            formData.append('file', file.attachment)
            formData.append('description', file.description)
            formData.append('reference_document_type_id', file.reference_document_type_id)
            formData.append('date_of_document', file.date_of_document)
            formData.append('unit', this.unit)
            formData.append('order_id', ORDER_ID)
            formData.append('order_service_id', ORDER_SERVICE_ID)
            formData.append('company_id', COMPANY_ID)
            formData.append('finance_id', FINANCE_ID)
            formData.append('comment_id', COMMENT_ID)
            formData.append('task_id', TASK_ID)
            axios.post(API_DOCUMENTS, formData, config)
                .then(({data}) => {
                  this.$emit('updateViewDocument', data)
                  this.$emit('updateEditedItemDocuments', {file: data, editIndex: this.whereDocumentLoadingItemIndexLocal})
                  file.loaded = true
                  this.checkedLoadingFile()
                  file.name = ''
                  file.attachment = ''
                  file.description = ''
                  this.$emit("update:uploadDocumentsNow", false)
                })
                .finally(() => {
                  this.multiUploadDocuments = false
                  this.dataOverlay = false
                  this.$emit('onFileOperationCompleted', true)
                  this.addMultiFile()
                })
          });
        } else {
          const formData = new FormData();
          formData.append('order_id', ORDER_ID)
          formData.append('order_service_id', ORDER_SERVICE_ID)
          formData.append('company_id', COMPANY_ID)
          formData.append('finance_id', FINANCE_ID)
          formData.append('comment_id', COMMENT_ID)
          formData.append('task_id', TASK_ID)
          formData.append('unit', this.unit)
          formData.append('files', [])
          for (let i = 0; i < this.multipleFiles.length; i++) {
            let file = this.multipleFiles[i];
            formData.append('files[' + i + ']', file);
          }
          axios.post(API_DOCUMENTS, formData, config)
              .then(({data}) => {
                  for (let doc in data){
                      this.$emit('updateViewDocument', data[doc])
                  }
                  this.$emit('updateEditedItemDocuments', {file: data, editIndex: this.whereDocumentLoadingItemIndexLocal})
                  this.$emit('update:uploadDocumentsNow', false)
                  this.$emit('documentLoaded', true)
                  this.makeToast('success', 'Документы добавлены')
              })
              .finally(() => {
                  this.multipleFiles = []
                  this.dataOverlay = false
                  this.$emit('onFileOperationCompleted', true)
              })
        }
        this.areAnyFilesHere = false;
      }
    },
    checkedLoadingFile() {
      let isLoading = true;
      this.files.forEach((file, index) => {
        if (file.loaded == false) {
          isLoading = false
        }
      })
      if (isLoading) {
        this.$emit('documentLoaded', true);
        this.files.length = 0;
        this.makeToast('success', 'Документ добавлен');
      }
    },
  }
}
</script>
